module.exports = __webpack_public_path__ + "img/full-logo.a1c45b5c.svg";